import { createStore } from 'satcheljs';
var initialTrustedSendersStore = {
    trustedSendersAndDomains: null,
};
var store = createStore('TrustedSenders', initialTrustedSendersStore)();
export default store;
//# sourceMappingURL=store.js.map